import configs from '../configs';

import { getSubheaders } from '../components/Table/utils';

const getYearList = () => {
	let years = [];
	for(let i = parseInt(configs.startingYear); i <= new Date().getFullYear(); i++) {
		years.push({ label: String(i), value: String(i) });
	}
	return years;
};

const getObjectFromArray = (array, value, key = 'value', parseString = true) => {
	const index = array.map(e => e[key]).indexOf(parseString ? String(value) : value);
	return index !== -1 ? array[index] : null;
};

const capitalizeFirstLetter = (input = '', seperator = ' ') => {
	return input
		.toLowerCase()
		.split(seperator)
		.map(e => (e.charAt(0).toUpperCase() + e.slice(1)))
		.join(seperator);
};

const flattenArray = (...arrays) => {
	let array = [];
	if(arrays.length) {
		arrays.forEach(e => {
			array = [...array, ...e];
		});
	}
	return array;
};

const getTotal = (array = [], key = 'value') => {
	return array.reduce((a, v) => a + v[key], 0);
};

const getFooterTotal = (headers, data) => {
	let tmp = {};
	let subheaders = getSubheaders(headers);
	subheaders = subheaders.filter(e => (e.type === 'float' || e.type === 'int'));

	subheaders.forEach(e => {
		tmp[e.id] = getTotal(data, e.id);
	});
	return tmp;
};

const generateNumber = (raw_number, digit = 2) => {
	let number = Number(raw_number);

	// invalid number
	if(isNaN(number)) return '-';

	// setup option
	let option = {
		minimumFractionDigits: digit, 
		maximumFractionDigits: digit
	};

	number = number.toLocaleString('en', option);
	return number;
};

const sortByKey = (array = [], key = 'value', desc) => {
	const tmp = Boolean(desc) ? -1 : 1;
	return array.sort((a, b) => {
		if(a[key] > b[key]) return tmp * 1;
		if(a[key] < b[key]) return tmp * -1;
		return 0;
	});
};

export {
	getYearList,
	getObjectFromArray,
	capitalizeFirstLetter,
	flattenArray,
	getTotal,
	getFooterTotal,
	generateNumber,
	sortByKey
};
